let spatialNavModule = null;

export async function loadSpatialNav() {
  spatialNavModule = await import('@noriginmedia/norigin-spatial-navigation');
  return spatialNavModule;
}

export function getSpatialNav() {
  return spatialNavModule; // Returns null on non-TV, or the module on TV
}
